exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".subcategory{padding:0 16px 0 0;margin:0 0 10px}.subcategory .subcategory-title{font-weight:400}.subcategory .subcategory-text{font-size:1.6rem;margin-bottom:0}.subcategory .subcategory-text:not(:first-child){margin-top:10px}.subcategory .doc-link{font-size:1.8rem;color:#5f8f93}.subcategory .doc-link:active,.subcategory .doc-link:focus,.subcategory .doc-link:hover,.subcategory .doc-link:visited{color:#5f8f93}.subcategory ul{margin-top:10px}@media screen and (max-width:480px){.subcategory .subcategory-text{font-size:1.15rem}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/stylus-loader!./src/containers/categorycontainer/subcategory.styl
// module id = 517
// module chunks = 0